﻿
(function() {
    "use strict";

    angular.module("app").controller("UsersController", UsersController);

    UsersController.$inject = ["userApi"];

    function UsersController(userApi) {
        var vm = this;

        vm.$onInit = onInit;
        vm.showDeletedView = false

        function checkAuthorization() {
            userApi.getCurrentUser().then((data) => {
                if (!data.roles || !data.roles.includes("Administrator")) {
                    window.location.href = "/"
                }
            })
        }

        function onInit() {
            checkAuthorization();
            vm.showDeletedView = (location.hash.indexOf('/deleted') > -1);
        }
    }
})();
